import React from 'react';
import { 
    translate,
    List, 
    Datagrid,
    TextInput, 
    TextField,
    Filter,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import LinkToCreate from './LinkToExam';
import LinkToHistory from './LinkToHistory'
//import DayDueCom from '../controls/DayToExpire'



const styles = {
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
};


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
}

const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
};

/*
const QuestionFilter = (props) => (
    <Filter {...props}>
      <TextInput source="exam_name" alwaysOn label="Exam Name" />
      <TextInput source="question" label="Question" />
    </Filter>
  );
  


const DayDue = ({record})=>(
  <DayDueCom record={record} />
)
*/


const DayExpire=({record})=>(
  <div>
    {`${(record.training_name).toUpperCase()} : ` }
                                     {record.day_to_exp < 0? <font color="red"><b>Overdue</b></font>: record.day_to_exp < 7? <font color="orange">Due in <b>{record.day_to_exp}</b> day(s)</font>: <font color="green">
                                     {record.day_to_exp !== '999' ? `Due in ${record.day_to_exp}  day(s)` : 'Completed' } </font>}  
    
    </div>
  )

export const CertificationList = ({ classes, ...props }) => (
  
    <List
    classes={classes}
    {...props}
    perPage={20}
    bulkActionButtons={false}
    title="Certifications"
  >
    <Datagrid >
      <TextField source="training_name" label="Training" />
      <TextField source="full_name" label="Name" />
      <LinkToCreate lable="Exams"/>
      <TextField source="day_to_exp"  label='Days to Expire' />
      <DayExpire />
      <LinkToHistory />
    </Datagrid>
  </List>
);


export default withStyles(listStyles)(CertificationList)
